<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Réinitialisez votre mot de passe</h1>

        <div
          class="alert alert-danger"
          role="alert"
          v-bind:class="{ hide: status.login.errorMessage == null }"
        >{{status.login.errorMessage}}</div>

        <form @submit.prevent="reset">
          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Email</label>
              <input type="text" class="form-control" v-model="loginForm.email" placeholder="Email" />
            </div>
          </div>

          <br />
          <div class="form-group">
            <button
              type="submit"
              class="btn btn-primary btn-xl"
              v-bind:class="{ hide: status.login.loading == true || status.login.done == true }"
            >Réinitialiser mon mot de passe</button>

            <div
              class="spinner-border text-primary"
              role="status"
              v-bind:class="{ hide: status.login.loading == false }"
            >
              <span class="sr-only">Demande de réinitialisation en cours...</span>
            </div>

            <div
              class="text-primary"
              role="status"
              v-bind:class="{ hide: status.login.done == false }"
            >
              <span>Demande de réinitialisation effectuée. 
                Si c'est bien votre email, vous allez recevoir un email de réinitialisation de mot de passe.</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "UserForget",
  getterMethods: null,
  props: ["email", "resetToken"],
  data() {
    return {
      loginForm: { email: "" },
      errorLogin: {},
      status: {
        login: { loading: false, errorMessage: null, done: false }
      }
    };
  },
  mounted() {
  },
  methods: {
    reset: function() {
      var vm = this;
      console.log(this.loginForm);
      vm.status.login.loading = true;
      vm.status.login.errorMessage = null;

      axios
        .post(process.env.BACKEND_URL + "/api/users/password/resettoken", vm.loginForm)
        .then(response => {
          vm.status.login.loading = false;
          vm.status.login.done = true;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == 500)
              vm.status.login.errorMessage =
                "Erreur serveur : <br /><i>" +
                JSON.stringify(error.response.data) +
                "</i>";
          } else
            vm.status.login.errorMessage =
              "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.login.loading = false;
        });

      return false;
    },
    register: function() {
      var vm = this;
      vm.status.register.loading = true;
      vm.status.register.errorMessage = null;

      axios
        .post(process.env.BACKEND_URL + "/api/users/register", vm.registerForm)
        .then(response => {
          console.log(response);

          if (response.status == 200) {
            vm.loginForm.email = vm.registerForm.email;
            vm.loginForm.password = vm.registerForm.password;

            vm.login();
          } else {
            vm.status.register.errorMessage = "Erreur non prise en charge";
          }

          vm.status.register.loading = false;
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 409)
              vm.status.register.errorMessage = "Utilisateur déjà existant";
            else if (error.response.status == 500)
              vm.status.register.errorMessage =
                "Erreur serveur : <br /><i>" +
                JSON.stringify(error.response.data) +
                "</i>";
          } else
            vm.status.register.errorMessage =
              "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.register.loading = false;
        });

      return false;
    }
  }
};
</script>

<style scope>
.container {
  padding-top: 40px;
}

a.search-list-item {
  display: block;
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/users/UserForget.vue